<!------------- ETC comments threads pops up ---------------->
	<div class="reject_popup" *ngIf="thread_msg !== null">
		<div class="reject_popup_wrapper">
			<div class="reject_popup_header">
				<h3>{{'RejectReason' | translate}}</h3><button class="pop_close" (click)="threadClose()"><i class="bi bi-x"></i></button>
			</div>
			<div class="reject_popup_body" *ngIf="thread_msg.length > 0; else noMsg">
				<ul>
					<li *ngFor="let msg of thread_msg" class="client asso">
						<h5>{{msg.modifyUserName}}<span>{{msg._modifyDate}}</span></h5>
						<p>{{msg.modifyComment}}</p>
					</li>
				</ul>
			</div>
			<ng-template #noMsg>
				<div class="reject_popup_body">
					<p>{{'NoComments' | translate}}</p>
				</div>
			</ng-template>
		</div>
	</div>
<!---------------------------- END ----------------------------->

<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto" *ngIf="monthDropdown.length > 0">
			<h2><label for="select_year_month">{{"SELECTDATE" | translate}}</label> </h2>
			<select 
			class="form-select" 
			aria-label="Month selection"
            [(ngModel)]="dropDowndate"
			(change)="fncCng($event)">
				<option *ngFor="let date of monthDropdown" [value]="date.dayDate">
					{{(lang == 'en') ? date.eNdate: date.jPdate}}
				</option>
			</select>
			<ng-container *ngIf="adminLevel === 0">
				<h2 class="pl20">{{'CompanyName' | translate}}:</h2>
				<p>{{companyName}}</p>
			</ng-container>
		</div>
	</section>
</div>
<!--  ############### Top Select Month End ################# -->

<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">
	
	<div class="time_sheet_ligend" *ngIf="lang === 'en'">
		<ul>
			<li class="status"><span>{{"STATUS" | translate}}</span></li>
			<li class="nSubmit"><s>{{"Status.N" | translate}}</s><span>{{"Status.NOTSUBMIT" | translate}}</span></li>
			<li class="submit"><s>{{"Status.S" | translate}}</s><span>{{"Status.SUBMIT" | translate}}</span></li>
			<li class="approve"><s>{{"Status.A" | translate}}</s><span>{{"Status.APPROVE" | translate}}</span></li>
			<li class="reject"><s>{{"Status.R" | translate}}</s><span>{{"Status.REJECT" | translate}}</span></li>
		</ul>
	</div>
	
	<!-- Search Filter with Save Button -->
	<div class="filter_section" *ngIf="monthDropdown.length > 0">
		<div class="search_wrapper">
			<label>{{"SearchByText" | translate}}:</label>
			<input type="text" class="form-control" (input)="onSearchFilter($event)" placeholder="{{'SearchKey' | translate}}" />
		</div>
		<div class="">{{"Approve-all-attention" | translate}}</div>
		<button class="butn save_entry btn" (click)="onSave()" [disabled]="isSaveDisabled">{{"SAVE" | translate}}</button>
	</div>
	
	<!--  ############### Data Table Start ################# -->
	<div class="client_associate_list" [class.lang-jp]="lang === 'jp'" [class.lang-en]="lang === 'en'">
		
		<!-- Desktop Table Header -->
		<div class="associate_table_heading desktop-header">
			<section>
				<article>
					<div class="tbl_section">{{"AssociatesList.Section" | translate}}</div>
					<div class="tbl_name">{{"AssociatesList.Name" | translate}}</div>
					<div class="tbl_date">{{"DATE" | translate}}</div>
					<div class="tbl_check select_all">
						<label class="switch">
							<input type="checkbox"
								[(ngModel)]="selectAll"
								[ngModelOptions]="{standalone: true}"
								(change)="toggleAllApprovals($event)" [disabled]="archive || !hasCheckableData">
							<span class="slider"></span>
						</label>
						<span class="pl5">{{"APPROVE" | translate}}</span>
					</div>
					<div class="tbl_status">{{"STATUS" | translate}}</div>
					<div class="tbl_reject">{{"REJECT" | translate}}</div>
					<div class="tbl_start">{{"START" | translate}}</div>
					<div class="tbl_finish">{{"FINISH" | translate}}</div>
					<div class="tbl_break">{{"BREAK" | translate}}</div>
					<div class="tbl_midnight_break">{{"MIDNIGHTBREAK" | translate}}</div>
					<div class="tbl_note">{{"NOTE" | translate}}</div>
					<div class="tbl_home">{{"HOME" | translate}}</div>
					<div class="tbl_expenses">{{"EXPENSES" | translate}}</div>
					<div class="tbl_amount">{{"AMOUNTOFEXPENSES" | translate}}</div>
				</article>
			</section>
		</div>
		
		<!-- Mobile Table Header -->
		<div class="associate_table_heading_mobile mobile-header">
			<aside>
				<div class="tbl_expand">{{"EXPAND" | translate}}</div>
				<div class="tbl_name">{{"AssociatesList.Name" | translate}}</div>
				<div class="tbl_check">
					<label class="switch">
						<input type="checkbox"
							[(ngModel)]="selectAll"
							[ngModelOptions]="{standalone: true}"
						(change)="toggleAllApprovals($event)" [disabled]="archive || !hasCheckableData">
						<span class="slider"></span>
					</label>
				</div>
				<div class="tbl_status">{{"STATUS" | translate}}</div>
				<div class="tbl_reject">{{"REJECT" | translate}}</div>
				<div class="tbl_start">{{"START" | translate}}</div>
				<div class="tbl_finish">{{"FINISH" | translate}}</div>
				<div class="tbl_break">{{"BREAK" | translate}}</div>
				<div class="tbl_midnight_break">{{"MIDNIGHTBREAKSHORT" | translate}}</div>
			</aside>
		</div>
		
		<!-- No Data Message -->
		<div class="empty_message" *ngIf="!isLoading && visibleData.length === 0">
			<p>{{"NoRecordsFound" | translate}}</p>
		</div>
		
		<!-- Data Rows -->
		<ng-container *ngFor="let item of visibleData; let i = index">
			<div class="associate_row" [ngClass]="{
				'tr_non_submit': item.status < 20,
				'tr_submit': item.status === 20,
				'tr_reject': item.status === 30,
				'tr_approve': item.status === 40
			}">
				<section>
					<aside>
						<div class="tbl_expand">
							<button class="expand" [class.active]="expandedRows[i]" (click)="toggleRow(i.toString())"></button>
						</div>
						<div class="tbl_name"><span class="staff-code">{{item.staffCode}}</span>{{item.staffName}}</div>
						<div class="tbl_check">
							<label class="switch" *ngIf="(item.status == 20)">
								<input type="checkbox" 
									[(ngModel)]="item.markedForSubmit" 
									[ngModelOptions]="{standalone: true}" 
									class="chkApproveStatus" 
									[disabled]="archive" 
									(change)="chkSubmitCnt()"/>
								<span class="slider"></span>
							</label>
						</div>
						<div class="tbl_status">
							<span [ngClass]="{ 'get_comment': item.status === 30 }" 
								(click)="onRejectClick(item)">
									{{ item._statusKey | translate }}
							</span>
						</div>
						<div class="tbl_reject">
							<div class="reject_save" *ngIf="(item.status == 20)">
								<label class="switch_radio">
									<input type="checkbox" 
										[(ngModel)]="item.markedForReject" 
										[ngModelOptions]="{standalone: true}" 
										class="chkStatus" 
										(change)="editReject(i)" 
										[disabled]="archive"/>
									<span class="slider"></span>
								</label>
							</div>
						</div>
						<div class="tbl_start">{{item.startTime}}</div>
						<div class="tbl_finish">{{item.endTime}}</div>
						<div class="tbl_break">{{item.breakMinutes}}</div>
						<div class="tbl_midnight_break">{{item.midnightBreakMinutes}}</div>
					</aside>
					<article [ngClass]="{ 'expanded': expandedRows[i] }">
						<div class="tbl_section">
							<ng-container *ngIf="adminLevel > 0">
								<span class="section-company">{{item.customerName}}</span>
								<span class="section-office">{{item.customerOfficeName}}</span>
							</ng-container>
							<span *ngIf="adminLevel <= 0">{{item.customerOfficeName}}</span>
						</div>
						<div class="tbl_name">
							<samp>{{"AssociatesList.Name" | translate}}</samp>
							<span class="staff-code">{{item.staffCode}}</span>
							<span>{{item.staffName}}</span>
						</div>
						<div class="tbl_date">
							<samp>{{"DATE" | translate}}</samp>
								<span>{{ item._dayInfo.day }} ({{ item._dayInfo.weekdayKey | translate }})</span>
						</div>
						<div class="tbl_check">
							<samp>チェック</samp>
							<label class="switch" *ngIf="(item.status == 20)">
								<input type="checkbox" 
									[(ngModel)]="item.markedForSubmit" 
									[ngModelOptions]="{standalone: true}" 
									class="chkApproveStatus" 
									[disabled]="archive" 
									(change)="chkSubmitCnt()"/>
								<span class="slider"></span>
							</label>
						</div>
						<div class="tbl_status">
							<samp>{{"STATUS" | translate}}</samp>
							<span [ngClass]="{ 'get_comment': item.status === 30 }" 
								(click)="onRejectClick(item)">
								{{ item._statusKey | translate }}
							</span>
						</div>
						<div class="tbl_reject">
							<samp>{{"REJECT" | translate}}</samp>
							<div class="reject_save" *ngIf="(item.status == 20)">
								<label class="switch_radio">
									<input type="checkbox" 
										[(ngModel)]="item.markedForReject" 
										[ngModelOptions]="{standalone: true}" 
										class="chkStatus" 
										(change)="editReject(i)" 
										[disabled]="archive"/>
									<span class="slider"></span>
								</label>
							</div>
						</div>
						<div class="tbl_start">
							<samp>{{"START" | translate}}</samp>
							<span>{{item.startTime}}</span>
						</div>
						<div class="tbl_finish">
							<samp>{{"FINISH" | translate}}</samp>
							<span>{{item.endTime}}</span>
						</div>
						<div class="tbl_break">
							<samp>{{"BREAK" | translate}}</samp>
							<span>{{item.breakMinutes}}</span>
						</div>
						<div class="tbl_midnight_break">
							<samp>{{"MIDNIGHTBREAK" | translate}}</samp>
							<span>{{item.midnightBreakMinutes}}</span>
						</div>
						<div class="tbl_note">
							<samp>{{"NOTE" | translate}}</samp>
								<span>{{item._noteKey | translate}}</span>
						</div>
						<div class="tbl_home">
							<samp>{{"HOME" | translate}}</samp>
							<label class="switch2">
								<input type="checkbox" [(ngModel)]="item.whf" [ngModelOptions]="{standalone: true}" disabled="">
								<span class="slider"></span>
							</label>
						</div>
						<div class="tbl_expenses">
							<samp>{{"EXPENSES" | translate}}</samp>
								<span>{{item._expensesKey | translate}}</span>
						</div>
						<div class="tbl_amount">
							<samp>{{"AMOUNTOFEXPENSES" | translate}}</samp>
							<span>{{item.cost}}</span>
						</div>
					</article>
					<!-- 否認理由入力行 -->
					<div class="reject_remarks_row" *ngIf="editingRow === i">
						<label>{{'ETC' | translate}}:</label>
						<input type="text" class="form-control"
							[(ngModel)]="item.etcRemarks"
							[ngModelOptions]="{standalone: true}"
							placeholder="{{'ETC' | translate}}" />
						<div class="remarks-buttons">
							<button name="cancel" class="cancel" (click)="cancelReject(i)" title="{{'CANCEL' | translate}}">cancel</button>
							<button name="save" class="save" (click)="saveReject(i)" title="{{'SAVE' | translate}}">save</button>
						</div>
					</div>
				</section>
			</div>
		</ng-container>
		
		<!-- PrimeNG Paginator -->
		<p-paginator 
			[rows]="itemsPerPage"
			[totalRecords]="filteredData.length"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="{{'Showing' | translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
			(onPageChange)="onPageChange($event)">
		</p-paginator>
		
	</div>
	<!--  ############### Data Table End ################# -->
	
</div>
<!--  ############### Middle Containt Area End ################# -->
